import {create} from 'zustand'
import { authSlice } from './authSlice'
import { siteSlice } from './siteSlice'
import { clinicFeaturesSlice } from './clinicFeaturesSlice'
import {persist,devtools} from 'zustand/middleware'

let useStore = (...a) =>({
        ...authSlice(...a),
        ...siteSlice(...a),
        ...clinicFeaturesSlice(...a),
    })

useStore = persist(useStore, {
    name: 'eyeconx-store',
    partialize: (state) => {
        const {
            clinicFeatures,
            clinicFeaturesLoaded,
            clinicFeaturesLoading,
            ...persistedState
        } = state;

        return persistedState;
    },
})
useStore = devtools(useStore)

export const useEyeconxStore = create(useStore)